import { render } from "./MessageCard.vue?vue&type=template&id=a8ea70ce&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"

import "./MessageCard.vue?vue&type=style&index=0&id=a8ea70ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a8ea70ce"

export default script